import $ from 'jquery';

export class SlickSlider {
  constructor() {
    this.slick = $('[data-slick]');
    this.init()
  }

  init() {
    if(this.slick.length <= 0) {
      return
    }

    if (!this.slick.hasClass('slick-initialized')) {
      this.slick.slick({
        dots: true,
        arrows: false,
        vertical: false,
        infinite: false,
        slidesToShow: 2,
        responsive: [
          {
            breakpoint: 980,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    }
  }
}


// WEBPACK FOOTER //
// ./scripts/main-modules/slick.js